"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var publicTrackerClient = _interopRequireWildcard(require("usage-tracker-public"));

var _CommonTrackerProperties = _interopRequireDefault(require("pricing-pages-unified-ui/utils/CommonTrackerProperties"));

var _default = function _default() {
  return publicTrackerClient.createTracker((0, _extends2.default)({}, _CommonTrackerProperties.default, {
    isExternalHost: false
  }));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/_PublicUsageTracker.js
// module id = 963
// module chunks = 6